import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
const Language = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "en",
      name: "en",
      validation: "",
      default: "",
      label: "en",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "de",
      name: "de",
      validation: "",
      default: "",
      label: "de",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "shortForm",
      name: "shortForm",
      validation: "",
      default: "",
      label: "shortForm",
      filter: true,
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "visible",
      name: "visible",
      validation: "",
      default: "",
      label: "visible",
      required: true,
      view: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        { id: true, value: t("everyOne") },
        { id: false, value: t("noOne") },
      ],
    },
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("Language")} - Whistleblowing24`;
  }, [t]);
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable {...props} api={`language`} itemTitle={sessionStorage.getItem("_lang") ?? "de"} shortName={`Language`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Language);
